import { render } from "./map.vue?vue&type=template&id=b7054cd6&scoped=true"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"

import "./map.vue?vue&type=style&index=0&id=b7054cd6&scoped=true&lang=less"

import exportComponent from "D:\\workCode\\cbc\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7054cd6"]])

export default __exports__